import * as common from './common.json';

export const fr = {
  common,
};
